import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { CniRolesGrid } from "@/features/cni-rbac/components/CniRolesGrid"

export const Route = createFileRoute("/_authed/cni/roles")({
  component: CniRolesPage,
})

function CniRolesPage() {
  const { t } = useTranslation("cni-rbac")
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4">
        <h1 className="text-lg font-semibold tracking-tight">{t("rolesPage.title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("rolesPage.subtitle")}</p>
      </div>
      <div className="flex-1 overflow-auto">
        <CniRolesGrid />
      </div>
    </div>
  )
}
